import React from 'react'
import { Card, Col, Row } from 'react-bootstrap';

function TodayAttendance({ attendance = [] }) {
  const cardStyle = {
    borderRadius: "12px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
    marginBottom: "20px",
  };

  const rowStyle = {
    padding: "8px 0",
    borderBottom: "1px solid #f0f0f0",
  };

  const headerStyle = {
    fontWeight: "600",
    borderBottom: "2px solid #dee2e6",
    paddingBottom: "8px",
  };

  return (
    <Card style={cardStyle}>
      <Card.Header className="bg-success text-white">
        <strong>Today's Attendance</strong>
      </Card.Header>
      <Card.Body>
        {attendance.length === 0 ? (
          <div className="text-muted">No employees attendance on today.</div>
        ) : (
          <div>
            <Row style={headerStyle} className="text-muted small">
              <Col sm={6}>Project Name</Col>
              <Col sm={6}>Total Present</Col>
            </Row>
            {attendance.map((att, index) => (
              <Row key={index} style={rowStyle}>
                <Col sm={6}>{att.projectName}</Col>
                <Col sm={6}>{att.totalPresent}</Col>
              </Row>
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  )
}



export default TodayAttendance